import { memo } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { LangInfo } from '../lang-info/LangInfo';
import { LangChooserToggleStyled } from './styled/LangChooserButtonStyled';
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

export const LangChooserButton = memo(({ isHideName, isHideArrowIcon, onClick }) => {
    const { lang } = useLangContext();
    return (
        <LangChooserToggleStyled onClick={onClick}>
            <LangInfo isHideName={isHideName} langName={lang.lang_name} iconName={lang.lang} />
            {!isHideArrowIcon && (
                <>
                    {' '}<KeyboardArrowDownIcon className='arrow-icon' />
                </>
            )}
        </LangChooserToggleStyled>
    );
})